"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrekkerEventBus = void 0;
const timeout = (cb) => window.setTimeout(cb, 200);
const whenIdle = window.requestIdleCallback || window.queueMicrotask || timeout;
class TrekkerEventBus {
    constructor() {
        this.listeners = [];
        this.eventListeners = {};
    }
    dispatchEvent(event) {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (_a = this.eventListeners[event.eventName]) === null || _a === void 0 ? void 0 : _a.forEach((listener) => {
            whenIdle(() => {
                listener(event.clone());
            });
        });
        this.listeners.forEach((listener) => {
            whenIdle(() => {
                listener(event.clone());
            });
        });
    }
    addEventListener(name, handler) {
        if (this.eventListeners[name]) {
            this.eventListeners[name].push(handler);
        }
        else {
            this.eventListeners[name] = [handler];
        }
    }
    removeEventListener(name, handler) {
        const index = this.eventListeners[name].indexOf(handler);
        if (index > -1) {
            this.eventListeners[name].splice(index, 1);
        }
    }
    addCatchAllEventListener(handler) {
        this.listeners.push(handler);
    }
    removeCatchAllEventListener(handler) {
        const index = this.listeners.indexOf(handler);
        if (index > -1) {
            this.listeners.splice(index, 1);
        }
    }
}
exports.TrekkerEventBus = TrekkerEventBus;
//# sourceMappingURL=bus.js.map